"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedSearchPropertiesSchema = exports.SharedUnitPropertiesSchema = exports.SharedFacilityPropertiesSchema = exports.SharedReservationPropertiesSchema = exports.SharedEcommerceTransactionPropertiesSchema = exports.SharedEcommerceUnitPropertiesSchema = exports.SharedEcommerceFacilityPropertiesSchema = exports.SharedEcommerceFacilitiesPropertiesSchema = exports.SharedUserPropertiesSchema = exports.SharedLinkPropertiesSchema = exports.SharedClickEventPropertiesSchema = exports.BaseEventPropertiesSchema = exports.ContactTypeSchema = exports.ContactType = exports.UnitSchema = exports.FacilitySchema = exports.DateStringSchema = exports.UrlUtmPropertiesSchema = exports.UrlPropertiesSchema = exports.UtmPropertiesSchema = exports.CurrencySchema = exports.Currency = exports.UtmParamQueryKeys = exports.TrackingPropertyKey = void 0;
const zod_1 = require("zod");
/**
 * Property Keys
 * These are all the valid property keys that can be used in events.
 */
var TrackingPropertyKey;
(function (TrackingPropertyKey) {
    TrackingPropertyKey["ACTUAL_MOVE_IN_DATE"] = "actual_move_in_date";
    TrackingPropertyKey["CART_PRODUCTS_COUNT"] = "cart_products_count";
    TrackingPropertyKey["CART_VALUE"] = "cart_value";
    TrackingPropertyKey["CHECKOUT_STEP"] = "checkout_step";
    TrackingPropertyKey["CLICK_ID"] = "click_id";
    TrackingPropertyKey["CLICK_NAME"] = "click_name";
    TrackingPropertyKey["CLICK_TEXT"] = "click_text";
    TrackingPropertyKey["CLICK_URL"] = "click_url";
    TrackingPropertyKey["CONTACT_TYPE"] = "contact_type";
    TrackingPropertyKey["CURRENCY"] = "currency";
    TrackingPropertyKey["DISCOUNTS"] = "discounts";
    TrackingPropertyKey["EMAIL"] = "email";
    TrackingPropertyKey["FACILITIES"] = "facilities";
    TrackingPropertyKey["FACILITIES_LIST"] = "facilities_list";
    TrackingPropertyKey["FACILITY"] = "facility";
    TrackingPropertyKey["FACILITY_BADGE"] = "facility_badge";
    TrackingPropertyKey["FACILITY_ID"] = "facility_id";
    TrackingPropertyKey["FACILITY_NAME"] = "facility_name";
    TrackingPropertyKey["FACILITY_PROMO"] = "facility_promo";
    TrackingPropertyKey["FACILITY_RANK"] = "facility_rank";
    TrackingPropertyKey["FIRST_NAME"] = "first_name";
    TrackingPropertyKey["FIRST_ORDER_DATE"] = "first_order_date";
    TrackingPropertyKey["FORM_ID"] = "form_id";
    TrackingPropertyKey["FORM_TARGET"] = "form_target";
    TrackingPropertyKey["FORM_URL"] = "form_url";
    TrackingPropertyKey["LAST_NAME"] = "last_name";
    TrackingPropertyKey["LAST_ORDER_DATE"] = "last_order_date";
    TrackingPropertyKey["LAST_UNIT_ADDED_DATE"] = "last_unit_added_date";
    TrackingPropertyKey["MOVE_IN_DATE"] = "move_in_date";
    TrackingPropertyKey["PAGE_NAME"] = "page_name";
    TrackingPropertyKey["PAGE_TYPE"] = "page_type";
    TrackingPropertyKey["PHONE"] = "phone";
    TrackingPropertyKey["PLANNED_MOVE_IN_DATE"] = "planned_move_in_date";
    TrackingPropertyKey["PRODUCTS"] = "products";
    TrackingPropertyKey["PROMOTION_CODE"] = "promotion_code";
    TrackingPropertyKey["RESERVATION_CONFIRMATION"] = "reservation_confirmation";
    TrackingPropertyKey["REVENUE"] = "revenue";
    TrackingPropertyKey["SEARCH_FILTERS"] = "search_filters";
    TrackingPropertyKey["SEARCH_LABEL"] = "search_label";
    TrackingPropertyKey["SEARCH_TERM"] = "search_term";
    TrackingPropertyKey["STEP"] = "step";
    TrackingPropertyKey["TAX"] = "tax";
    TrackingPropertyKey["TOTAL_PAID"] = "total_paid";
    TrackingPropertyKey["UNIT"] = "unit";
    TrackingPropertyKey["UNIT_ID"] = "unit_id";
    TrackingPropertyKey["UNIT_PROMO"] = "unit_promo";
    TrackingPropertyKey["VIDEO_DURATION"] = "video_duration";
    TrackingPropertyKey["VIDEO_DURATION_PLAYED"] = "video_duration_played";
    TrackingPropertyKey["VIDEO_NAME"] = "video_name";
    TrackingPropertyKey["VISIT_ID"] = "visit_id";
    TrackingPropertyKey["CATEGORY"] = "category";
    TrackingPropertyKey["LABEL"] = "label";
    TrackingPropertyKey["PAGE_TITLE"] = "page_title";
    TrackingPropertyKey["NON_INTERACTION"] = "nonInteraction";
    TrackingPropertyKey["EXPERIMENT_SOURCE"] = "experiment_source";
    TrackingPropertyKey["EXPERIMENT_ID"] = "experiment_id";
    TrackingPropertyKey["VARIANT_ID"] = "variant_id";
    TrackingPropertyKey["UTM_SOURCE"] = "utm_source";
    TrackingPropertyKey["UTM_MEDIUM"] = "utm_medium";
    TrackingPropertyKey["UTM_CAMPAIGN"] = "utm_campaign";
    TrackingPropertyKey["UTM_CONTENT"] = "utm_content";
    TrackingPropertyKey["UTM_TERM"] = "utm_term";
    TrackingPropertyKey["UTM_KEYWORD"] = "utm_keyword";
    TrackingPropertyKey["UTM_ADGROUP"] = "utm_adgroup";
    TrackingPropertyKey["GCLID"] = "gclid";
    TrackingPropertyKey["PATH"] = "path";
    TrackingPropertyKey["REFERRER"] = "referrer";
    TrackingPropertyKey["URL"] = "url";
    TrackingPropertyKey["REFERRER_PATH"] = "referrer_path";
    TrackingPropertyKey["PAGE_PATH_LEVEL_1"] = "page_path_level_1";
    TrackingPropertyKey["PAGE_PATH_LEVEL_2"] = "page_path_level_2";
    TrackingPropertyKey["PAGE_PATH_LEVEL_3"] = "page_path_level_3";
    TrackingPropertyKey["PAGE_SEARCH"] = "page_search";
    TrackingPropertyKey["PAGE_HASH"] = "page_hash";
    TrackingPropertyKey["PAGE_HOSTNAME"] = "page_hostname";
})(TrackingPropertyKey || (exports.TrackingPropertyKey = TrackingPropertyKey = {}));
/**
 * This const is meant to be a record of the keys as they will appear in the URL.
 * This is to be used _separately_ from the TrackingPropertyKey enum, which defines the keys used in the events.
 *
 * It just so _happens_ that the keys are the same, but we need to preserve the ability to differentiate between the two should
 * the need arise, for example, to call event property key `utmSource` but still be able to grab the `utm_source` value from the URL.
 */
exports.UtmParamQueryKeys = {
    "UTM_SOURCE": "utm_source",
    "UTM_MEDIUM": "utm_medium",
    "UTM_CAMPAIGN": "utm_campaign",
    "UTM_CONTENT": "utm_content",
    "UTM_TERM": "utm_term",
    "UTM_KEYWORD": "utm_keyword",
    "UTM_ADGROUP": "utm_adgroup",
    "GCLID": "gclid",
};
/**
 * A currency enum used for ecommerce events.
 */
var Currency;
(function (Currency) {
    Currency["USD"] = "usd";
})(Currency || (exports.Currency = Currency = {}));
exports.CurrencySchema = zod_1.z.nativeEnum(Currency);
exports.UtmPropertiesSchema = zod_1.z.object({
    [TrackingPropertyKey.UTM_SOURCE]: zod_1.z.string(),
    [TrackingPropertyKey.UTM_MEDIUM]: zod_1.z.string(),
    [TrackingPropertyKey.UTM_CAMPAIGN]: zod_1.z.string(),
    [TrackingPropertyKey.UTM_CONTENT]: zod_1.z.string(),
    [TrackingPropertyKey.UTM_TERM]: zod_1.z.string(),
    [TrackingPropertyKey.UTM_KEYWORD]: zod_1.z.string(),
    [TrackingPropertyKey.UTM_ADGROUP]: zod_1.z.string(),
    [TrackingPropertyKey.GCLID]: zod_1.z.string(),
});
exports.UrlPropertiesSchema = zod_1.z.object({
    [TrackingPropertyKey.PATH]: zod_1.z.string(),
    [TrackingPropertyKey.REFERRER]: zod_1.z.string(),
    [TrackingPropertyKey.PAGE_TITLE]: zod_1.z.string(),
    [TrackingPropertyKey.URL]: zod_1.z.string(),
    [TrackingPropertyKey.REFERRER_PATH]: zod_1.z.string(),
    [TrackingPropertyKey.PAGE_PATH_LEVEL_1]: zod_1.z.string(),
    [TrackingPropertyKey.PAGE_PATH_LEVEL_2]: zod_1.z.string(),
    [TrackingPropertyKey.PAGE_PATH_LEVEL_3]: zod_1.z.string(),
    [TrackingPropertyKey.PAGE_SEARCH]: zod_1.z.string(),
    [TrackingPropertyKey.PAGE_HASH]: zod_1.z.string(),
    [TrackingPropertyKey.PAGE_HOSTNAME]: zod_1.z.string(),
});
// combined schemas
exports.UrlUtmPropertiesSchema = zod_1.z.object({
    ...exports.UtmPropertiesSchema.shape,
    ...exports.UrlPropertiesSchema.shape,
});
/**
 * DateString
 * An ISO String date
 */
exports.DateStringSchema = zod_1.z.string().datetime();
/**
 * Facility
 * A facility object
 */
exports.FacilitySchema = zod_1.z.object({
    id: zod_1.z.number(),
    name: zod_1.z.string(),
    location: zod_1.z.string(),
});
/**
 * Unit
 * A unit object
 */
exports.UnitSchema = zod_1.z.object({
    id: zod_1.z.number(),
    variant_size: zod_1.z.string(),
    price: zod_1.z.number(),
    quantity: zod_1.z.number(),
    currency: zod_1.z.nativeEnum(Currency),
});
/**
 * A contact type enum used for contact events.
 */
var ContactType;
(function (ContactType) {
    ContactType["EMAIL"] = "mailto";
    ContactType["PHONE"] = "tel";
})(ContactType || (exports.ContactType = ContactType = {}));
exports.ContactTypeSchema = zod_1.z.nativeEnum(ContactType);
/**
 * All events use these properties
 */
exports.BaseEventPropertiesSchema = zod_1.z.object({});
/**
 * Anything that is a click (links, buttons) can use these properties.
 */
exports.SharedClickEventPropertiesSchema = zod_1.z.object({
    [TrackingPropertyKey.CLICK_TEXT]: zod_1.z.string(),
    [TrackingPropertyKey.CLICK_ID]: zod_1.z.string(),
    [TrackingPropertyKey.CLICK_NAME]: zod_1.z.string(),
});
/**
 * Anything that follows a URL can use these properties.
 */
exports.SharedLinkPropertiesSchema = zod_1.z.object({
    [TrackingPropertyKey.CLICK_URL]: zod_1.z.string(),
});
/** USER */
/**
 * Any event that includes user information can use these properties.
 */
exports.SharedUserPropertiesSchema = zod_1.z.object({
    [TrackingPropertyKey.FIRST_NAME]: zod_1.z.string().optional(),
    [TrackingPropertyKey.LAST_NAME]: zod_1.z.string().optional(),
    [TrackingPropertyKey.EMAIL]: zod_1.z.string().optional(),
    [TrackingPropertyKey.PHONE]: zod_1.z.string().optional(),
});
/** ECOMMERCE */
/**
 * Any event that includes ecommerce information about MULTIPLE
 * facilities can use these properties.
 */
exports.SharedEcommerceFacilitiesPropertiesSchema = zod_1.z.object({
    [TrackingPropertyKey.FACILITIES]: exports.FacilitySchema.array(),
});
/**
 * Any event that includes ecommerce information about a facility
 * can use these properties.
 */
exports.SharedEcommerceFacilityPropertiesSchema = zod_1.z.object({
    [TrackingPropertyKey.FACILITY]: exports.FacilitySchema,
});
/**
 * Any event that includes ecommerce information about a unit
 * can use these properties.
 */
exports.SharedEcommerceUnitPropertiesSchema = zod_1.z.object({
    [TrackingPropertyKey.UNIT]: exports.UnitSchema,
});
/**
 * Any event that includes ecommerce information about a transaction
 * can use these properties.
 */
exports.SharedEcommerceTransactionPropertiesSchema = zod_1.z.object({
    [TrackingPropertyKey.UNIT]: exports.UnitSchema.extend({
        [TrackingPropertyKey.TOTAL_PAID]: zod_1.z.number(),
    }),
});
/**
 * Any event that includes reservation information can use these properties.
 */
exports.SharedReservationPropertiesSchema = zod_1.z.object({
    [TrackingPropertyKey.RESERVATION_CONFIRMATION]: zod_1.z.string(),
    [TrackingPropertyKey.TAX]: zod_1.z.number(),
    [TrackingPropertyKey.DISCOUNTS]: zod_1.z.number(),
    [TrackingPropertyKey.PROMOTION_CODE]: zod_1.z.string(),
    [TrackingPropertyKey.REVENUE]: zod_1.z.number(),
    [TrackingPropertyKey.CURRENCY]: exports.CurrencySchema,
});
/**
 * Any event that includes facility information can use these properties.
 */
exports.SharedFacilityPropertiesSchema = zod_1.z.object({
    [TrackingPropertyKey.FACILITY_ID]: zod_1.z.string(),
    [TrackingPropertyKey.FACILITY_NAME]: zod_1.z.string(),
    [TrackingPropertyKey.FACILITY_RANK]: zod_1.z.number(),
    [TrackingPropertyKey.FACILITY_BADGE]: zod_1.z.string(),
    [TrackingPropertyKey.FACILITY_PROMO]: zod_1.z.string(),
});
/**
 * Any event that includes unit information can use these properties.
 */
exports.SharedUnitPropertiesSchema = zod_1.z.object({
    [TrackingPropertyKey.UNIT_PROMO]: zod_1.z.string(),
    [TrackingPropertyKey.UNIT_ID]: zod_1.z.string(),
});
/**
 * Shared Search Properties
 */
exports.SharedSearchPropertiesSchema = zod_1.z.object({
    [TrackingPropertyKey.SEARCH_TERM]: zod_1.z.string(),
    [TrackingPropertyKey.SEARCH_FILTERS]: zod_1.z.string(),
    [TrackingPropertyKey.SEARCH_LABEL]: zod_1.z.string(),
});
//# sourceMappingURL=shared.js.map